// ai会记任务
import { PAGE_LEVEL } from '@/constants';
export default {
  meta: { localeModules: ['aiNotes'] },
  path: '/aiNoteTask',
  redirect: '/aiNoteTask/index',
  children: [
    // 列表页
    {
      path: 'index',
      name: 'aiNoteTaskList',
      component: () => import(/* webpackChunkName: 'ai-note-task' */ '@/pages/aiNoteTask/index'),
      meta: {
        name: 'routers.ai_note_task_ai_note_task_list',
        componentName: 'AINoteList',
        pageLevel: PAGE_LEVEL.FIRST,
        keepAlive: true
      }
    }
  ]
};
